import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppGuard } from '../../services/auth.guard';
import { PlanejamentoComponent } from './planejamento/planejamento.component';
import { DiarioObraComponent } from './diario-obra/diario-obra.component';

const routes: Routes = [
  {
    path: 'planejamento',
    component: PlanejamentoComponent,
    canActivate: [AppGuard],
    data: { requiredRoles: ['NuAdmin'] },
  },
  {
    path: 'planejamento/diario',
    component: DiarioObraComponent,
    canActivate: [AppGuard],
    data: { requiredRoles: ['NuAdmin'] },
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class PlanejamentoRoutingModule {}
